module.exports = __webpack_public_path__ + "static/kubernetes2-1fb0c0440cab80267048e642802659f9.svg";